import React from "react";
import Users from "../Components/Users/Users";

const UsersPage = () => {
  return <Users />;
};

export default UsersPage;
